import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { AdminCard } from "@/pages/admin/adminUi";

const PIPELINE = ["NEW", "PRE_SCREENING", "UNDER_REVIEW", "COMMERCIAL_CONTACT", "SELECTED", "NOT_SELECTED", "WAITLIST"];
const PIPE_LABEL = { NEW: "New", PRE_SCREENING: "Pre-Screening", UNDER_REVIEW: "Under Review", COMMERCIAL_CONTACT: "Commercial", SELECTED: "Selected", NOT_SELECTED: "Not Selected", WAITLIST: "Waitlist" };

function Metric({ label, value, sub, testid }) {
  return (
    <AdminCard className="p-6 md:p-8">
      <p className="text-[10px] tracking-[0.22em] uppercase text-ivory/45">{label}</p>
      <p className="mt-4 font-serif text-4xl md:text-5xl text-ivory" data-testid={testid}>{value}</p>
      {sub && <p className="mt-2 text-[11px] text-gold/70">{sub}</p>}
    </AdminCard>
  );
}

export default function Dashboard() {
  const [m, setM] = useState(null);
  const [counts, setCounts] = useState({});

  useEffect(() => {
    api.get("/admin/metrics").then((r) => setM(r.data));
    api.get("/admin/applications").then((r) => {
      const c = {};
      r.data.applications.forEach((a) => { c[a.status] = (c[a.status] || 0) + 1; });
      setCounts(c);
    });
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-10">
        <p className="text-[11px] tracking-[0.3em] uppercase text-gold">VillaFlow Selection</p>
        <h1 className="mt-3 font-serif font-light text-4xl md:text-5xl text-ivory">Dashboard</h1>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        <Metric label="Applications" value={m?.applications ?? "—"} testid="metric-applications" />
        <Metric label="Under Review" value={m?.under_review ?? "—"} testid="metric-under-review" />
        <Metric label="Selected" value={m?.selected ?? "—"} testid="metric-selected" />
        <Metric label="Not Selected" value={m?.not_selected ?? "—"} testid="metric-not-selected" />
        <Metric label="Invitations Sent" value={m?.invitations_sent ?? "—"} testid="metric-invitations" />
        <Metric label="Invitation Conversion" value={m ? `${m.invitation_conversion_rate}%` : "—"} testid="metric-conversion" />
      </div>

      {/* Founding */}
      <AdminCard className="mt-4 p-8 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div>
          <p className="text-[10px] tracking-[0.22em] uppercase text-ivory/45">The Founding 20</p>
          <p className="mt-3 font-serif text-3xl text-ivory">
            {m?.founding_closed ? <span className="text-gold">Founding Collection Closed</span> : <><span className="text-gold" data-testid="founding-members-count">{m?.founding_members ?? 0}</span> <span className="text-ivory/40">/ {m?.founding_target ?? 20}</span></>}
          </p>
        </div>
        <div className="w-full md:w-80 h-1.5 bg-navy-900 border border-ivory/10">
          <div className="h-full bg-gold transition-all" style={{ width: `${Math.min(100, ((m?.founding_members || 0) / (m?.founding_target || 20)) * 100)}%` }} />
        </div>
      </AdminCard>

      {/* Pipeline */}
      <div className="mt-10">
        <h2 className="text-[11px] tracking-[0.25em] uppercase text-ivory/50 mb-4">Application Pipeline</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-px bg-ivory/10 border border-ivory/10">
          {PIPELINE.map((s) => (
            <Link key={s} to={`/admin/applications?status=${s}`} className="bg-navy-800 hover:bg-navy-700 transition-colors p-5 text-center" data-testid={`pipeline-${s}`}>
              <p className="font-serif text-3xl text-ivory">{counts[s] || 0}</p>
              <p className="mt-2 text-[9px] tracking-[0.15em] uppercase text-ivory/45">{PIPE_LABEL[s]}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
